import type { FC } from 'react'

import { NameAvatar } from '@skytech/ui/NameAvatar'
import { Td } from '@skytech/ui/Table/Td'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import Highlight from '@/components/Highlight'
import { LocalDate } from '@/components/LocalDate'
import { TrLink } from '@/components/TrLink'
import { APP_ROUTES } from '@/util/app-routes'

import type { SalaryDeductionApplication } from '../types'

export const SalaryDeductionListItem: FC<{
  item: SalaryDeductionApplication
  searchFilter: string
}> = ({ item, searchFilter }) => (
  <TrLink path={APP_ROUTES.EMPLOYEES_SALARY_DEDUCTION_APPLICATION.replace(':id', String(item.id))}>
    <Td className="is-mobile-hidden">
      <NameAvatar name={item.user} />
    </Td>
    <Td>
      <Highlight pattern={searchFilter} text={item.user} />
      <br />
      <Highlight pattern={searchFilter} text={item.code} />
    </Td>

    <Td className="is-mobile-hidden">
      <Highlight pattern={searchFilter} text={item.manager} />
      <br />
      <Highlight pattern={searchFilter} text={item.deputyManager} />
    </Td>
    <Td className="is-mobile-hidden">
      <Highlight pattern={searchFilter} text={item.modifiedBy} />
    </Td>

    <Td>
      <Highlight pattern={searchFilter} text={item.product} />
      <br />
    </Td>
    <Td className="is-mobile-hidden">
      <LocalDate date={item.fromPeriod} />
    </Td>

    <Td className="text-right">
      <FormattedNumberWithCurrency amount={item.sdaAmount} precision={2} />
    </Td>

    <Td className="is-mobile-hidden text-right">
      <FormattedNumberWithCurrency amount={item.amount} precision={2} />
    </Td>
  </TrLink>
)
